import createClient, { type Middleware } from 'openapi-fetch'
import type { components, paths } from './schema'

export type { components, paths }

// Typed client over the generated schema. Paths, params, bodies and
// responses are all derived from api/openapi.yaml — run `make gen` after
// editing it. Same-origin cookies carry the session on web.
export type ApiError = components['schemas']['Error']
export type User = components['schemas']['User']
export type Channel = components['schemas']['Channel']
export type Message = components['schemas']['Message']
export type MessagePage = components['schemas']['MessagePage']
export type Attachment = components['schemas']['Attachment']
export type Reaction = components['schemas']['Reaction']

const acceptJson: Middleware = {
  onRequest({ request }) {
    if (!request.headers.has('Accept')) request.headers.set('Accept', 'application/json')
    return request
  },
}

export function createApi(baseUrl = '/api') {
  const client = createClient<paths>({ baseUrl, credentials: 'same-origin' })
  client.use(acceptJson)
  return client
}

export const api = createApi()
